import { INCOME_CHECKLIST, GROSS_LABEL } from './common';
import { payFrequencyOptions } from 'components/Organisms/FormIncomeAndAssets/LinkedFields';
import { lowercaseFirstLetter } from './utils';

export const DEFAULT_INCOME_FIELDS = [
  {
    name: `${INCOME_CHECKLIST}.employment`,
    label: 'Employment / Anticipated Employment',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.employmentIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.selfEmployment`,
    label: 'Self-Employment',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.selfEmploymentIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.militaryPay`,
    label: 'Military Pay',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.militaryPayIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.notWorking`,
    label: 'Not Working',
    type: 'choice',
  },
  {
    name: `${INCOME_CHECKLIST}.unemploymentBenefits`,
    label: 'Unemployment Benefits',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.unemploymentBenefitsIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.socialSecurity`,
    label: 'Social Security, SSD',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.socialSecurityIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.socialSecurityClaimNumber`,
        label: 'SSN Benefits Claim Number (if different from SSN)',
        type: 'text',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.supplementalSecurity`,
    label: 'Supplemental Security Income (SSI)',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurityIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurityClaimNumber`,
        label: 'SSN Benefits Claim Number (if different from SSN)',
        type: 'text',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.vaBenefits`,
    label: 'V.A. Benefits',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.vaBenefitsIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.tanf`,
    label: 'TANF (AFDC)',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.tanfIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.disability`,
    label: "Disability, Worker's Comp.",
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.disabilityIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.recurringGift`,
    label: 'Recurring Gift',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.recurringGiftIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.retirement`,
    label: 'Regular Pmts from Retirement Acct.',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.retirementIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.trust`,
    label: 'Regular Pmts from Trust Acct.',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.trustIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.absentFamilyMember`,
    label: 'Income from Temporarily Absent Family Member',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.absentFamilyMemberIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.other`,
    label: 'Other',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.otherIncomeName`,
        label: 'Other Name',
        type: 'text',
      },
      {
        name: `${INCOME_CHECKLIST}.otherIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.otherIncomeType`,
        label: 'Income Type',
        type: 'incomeType',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.courtOrderedChildSupport`,
    label: 'Do you have court ordered or an agreement for child support?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.courtOrderedChildSupportIncome`,
        label: 'Amount Ordered',
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.receivingChildSupport`,
    label: 'Are you receiving the ordered child support?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.receivingChildSupportIncome`,
        label: 'Amount Receiving',
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.collectChildSupport`,
    label: 'Have reasonable efforts been made to collect?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.collectChildSupportState`,
        label: 'State',
        type: 'state',
      },
      {
        name: `${INCOME_CHECKLIST}.collectChildSupportCounty`,
        label: 'County',
        type: 'county',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.anticipateChildSupport`,
    label: 'Do you anticipate child support?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.anticipateChildSupportState`,
        label: 'State',
        type: 'state',
      },
      {
        name: `${INCOME_CHECKLIST}.anticipateChildSupportCounty`,
        label: 'County',
        type: 'county',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.publicHousing`,
    label: 'Public Housing',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.publicHousingText`,
        label: 'Public Housing Authority',
        type: 'text',
      },
    ],
  },
];

// This contains the pay frequency, pay rate, and hours/months/weeks fields for each income
export const INCOME_FORM_WITH_PAYDATA = [
  {
    name: `${INCOME_CHECKLIST}.employment`,
    label: 'Employment / Anticipated Employment',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.employmentIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.employmentPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.employmentPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.employmentHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.selfEmployment`,
    label: 'Self-Employment',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.selfEmploymentIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.selfEmploymentPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.selfEmploymentPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.selfEmploymentHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.militaryPay`,
    label: 'Military Pay',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.militaryPayIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.militaryPayPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.militaryPayPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.militaryPayHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.notWorking`,
    label: 'Not Working',
    type: 'choice',
  },
  {
    name: `${INCOME_CHECKLIST}.unemploymentBenefits`,
    label: 'Unemployment Benefits',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.unemploymentBenefitsIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.unemploymentBenefitsPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.unemploymentBenefitsPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.unemploymentBenefitsHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.socialSecurity`,
    label: 'Social Security, SSD',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.socialSecurityIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.socialSecurityPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.socialSecurityPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.socialSecurityHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.socialSecurityClaimNumber`,
        label: 'SSN Benefits Claim Number (if different from SSN)',
        type: 'text',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.supplementalSecurity`,
    label: 'Supplemental Security Income (SSI)',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurityIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurityPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurityPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurityHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurityClaimNumber`,
        label: 'SSN Benefits Claim Number (if different from SSN)',
        type: 'text',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.vaBenefits`,
    label: 'V.A. Benefits',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.vaBenefitsIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.vaBenefitsPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.vaBenefitsPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.vaBenefitsHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.tanf`,
    label: 'TANF (AFDC)',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.tanfIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.tanfPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.tanfPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.tanfHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.disability`,
    label: "Disability, Worker's Comp.",
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.disabilityIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.disabilityPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.disabilityPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.disabilityHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.recurringGift`,
    label: 'Recurring Gift',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.recurringGiftIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.recurringGiftPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.recurringGiftPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.recurringGiftHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.retirement`,
    label: 'Regular Pmts from Retirement Acct.',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.retirementIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.retirementPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.retirementPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.retirementHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.trust`,
    label: 'Regular Pmts from Trust Acct.',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.trustIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.trustPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.trustPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.trustHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.absentFamilyMember`,
    label: 'Income from Temporarily Absent Family Member',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.absentFamilyMemberIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.absentFamilyMemberPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.absentFamilyMemberPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.absentFamilyMemberHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.other`,
    label: 'Other',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.otherIncomeName`,
        label: 'Other Name',
        type: 'text',
      },
      {
        name: `${INCOME_CHECKLIST}.otherIncome`,
        label: GROSS_LABEL,
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.otherIncomeType`,
        label: 'Income Type',
        type: 'incomeType',
      },
      {
        name: `${INCOME_CHECKLIST}.otherPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.otherPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.otherHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.courtOrderedChildSupport`,
    label: 'Do you have court ordered or an agreement for child support?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.courtOrderedChildSupportIncome`,
        label: 'Amount Ordered',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.courtOrderedChildSupportPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.courtOrderedChildSupportPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.courtOrderedChildSupportHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.receivingChildSupport`,
    label: 'Are you receiving the ordered child support?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.receivingChildSupportIncome`,
        label: 'Amount Receiving',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.receivingChildSupportPayFrequency`,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.receivingChildSupportPayRate`,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.receivingChildSupportHoursWeeksMonths`,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.collectChildSupport`,
    label: 'Have reasonable efforts been made to collect?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.collectChildSupportState`,
        label: 'State',
        type: 'state',
      },
      {
        name: `${INCOME_CHECKLIST}.collectChildSupportCounty`,
        label: 'County',
        type: 'county',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.anticipateChildSupport`,
    label: 'Do you anticipate child support?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.anticipateChildSupportState`,
        label: 'State',
        type: 'state',
      },
      {
        name: `${INCOME_CHECKLIST}.anticipateChildSupportCounty`,
        label: 'County',
        type: 'county',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.publicHousing`,
    label: 'Public Housing',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.publicHousingText`,
        label: 'Public Housing Authority',
        type: 'text',
      },
    ],
  },
];

export const ALT_PAY_TYPE_NAME = 'PayType';
export const ALT_INCOME_NAME = 'Income';
export const ALT_PAY_FREQUENCY_NAME = 'PayFrequency';
export const ALT_PAY_RATE_NAME = 'PayRate';
export const ALT_HOURS_WEEKS_MONTHS_NAME = 'HoursWeeksMonths';

export const payFrequencyOptionsMap = {
  hourly: {
    label: 'Hours/Week',
    value: 52,
  },
  weekly: {
    label: 'Weeks',
    value: 52,
  },
  biWeekly: {
    label: 'Hours/Week',
    value: 26,
  },
  monthly: {
    label: 'Months',
    value: 12,
  },
  semiMonthly: {
    label: 'Hours/Week',
    value: 24,
  },
  annually: {
    label: 'Years',
    value: 1,
  },
  default: {
    label: 'Hours/Weeks/Months',
    value: 1,
  },
};
export const getRegularUnitsFrequencyOptions = () =>
  payFrequencyOptions
    .filter((option) => {
      return /^(week|month|annual)ly$/i.test(option.value);
    })
    .map((option) => option.value);

export const isDisableHoursWeeksMonths = (selectedOption) => {
  const optionsThatShouldDisableHoursWeeksMonths =
    getRegularUnitsFrequencyOptions();
  return optionsThatShouldDisableHoursWeeksMonths
    .filter((option) => option !== 'monthly')
    .includes(selectedOption);
};

const getInput = (name) => document.querySelector(`input[name="${name}"]`);
const getSelect = (name) => document.querySelector(`select[name="${name}"]`);

const getLabel = (name) => document.querySelector(`label[for="${name}"]`);
const onPayFrequencyChange =
  (fieldNamePrefix, parentFieldName) =>
  ({ target }) => {
    const { payFrequencyName, payRateName, hoursWeeksMonthsName, incomeName } =
      getPayDataFieldNames(fieldNamePrefix, target, parentFieldName);

    const { value } = target;

    const selectedOption = (
      payFrequencyOptions.find((option) => option.value === value) ?? {}
    ).value;

    const hoursWeeksMonthsMapping =
      payFrequencyOptionsMap[selectedOption] ?? payFrequencyOptionsMap.default;

    const hoursWeeksMonthsLabel = getLabel(hoursWeeksMonthsName);

    const hoursWeeksMonths = getInput(hoursWeeksMonthsName);

    if (isDisableHoursWeeksMonths(selectedOption)) {
      hoursWeeksMonths.setAttribute('disabled', 'true');
      hoursWeeksMonths.value = hoursWeeksMonthsMapping.value;
    } else {
      hoursWeeksMonths.removeAttribute('disabled');
    }

    if (selectedOption === 'monthly') {
      hoursWeeksMonths.value = hoursWeeksMonthsMapping.value;
    }

    hoursWeeksMonthsLabel.innerText = hoursWeeksMonthsMapping.label;

    onPayDataChange(
      payFrequencyName,
      payRateName,
      hoursWeeksMonthsName,
      incomeName,
    );
  };
export const calculateIncome = (
  payFrequencyWeeks,
  payRate,
  hoursWeeksMonths,
) => {
  if (isNaN(payFrequencyWeeks) || isNaN(payRate) || isNaN(hoursWeeksMonths)) {
    return 0;
  }
  return payFrequencyWeeks * payRate * hoursWeeksMonths;
};
export const onHoursWeeksMonthsChange =
  (fieldNamePrefix, parentFieldName) =>
  ({ target }) => {
    const { payFrequencyName, payRateName, hoursWeeksMonthsName, incomeName } =
      getPayDataFieldNames(fieldNamePrefix, target, parentFieldName);

    onPayDataChange(
      payFrequencyName,
      payRateName,
      hoursWeeksMonthsName,
      incomeName,
    );
  };
export const getPayFrequencyWeeks = (selectedOption) => {
  if (
    isDisableHoursWeeksMonths(selectedOption) ||
    selectedOption === 'monthly'
  ) {
    return 1;
  }

  const frequencyWeeksRelation =
    payFrequencyOptionsMap?.[selectedOption] ?? payFrequencyOptionsMap.default;
  return frequencyWeeksRelation.value;
};
export const onPayDataChange = (
  payFrequencyName,
  payRateName,
  hoursWeeksMonthsName,
  incomeName,
) => {
  const payFrequencyWeeks = getPayFrequencyWeeks(
    getSelect(payFrequencyName)?.value,
  );
  const payRate = Number(getInput(payRateName)?.value ?? 0);
  const hoursWeeksMonths = Number(getInput(hoursWeeksMonthsName)?.value ?? 0);

  const finalIncome = calculateIncome(
    payFrequencyWeeks,
    payRate,
    hoursWeeksMonths,
  );
  getInput(incomeName).value = finalIncome.toFixed(2);
};
export const getPayDataFieldNames = (
  fieldNamePrefix,
  target,
  parentFieldName,
) => {
  const { name } = target;
  const index = name.match(/\[(\d)\]/)?.[0] ?? null;

  const incomeName = index
    ? `${fieldNamePrefix}${index}.${ALT_INCOME_NAME}`
    : `${parentFieldName}${ALT_INCOME_NAME}`;
  const hoursWeeksMonthsName = index
    ? `${fieldNamePrefix}${index}.${ALT_HOURS_WEEKS_MONTHS_NAME}`
    : `${parentFieldName}${ALT_HOURS_WEEKS_MONTHS_NAME}`;
  const payRateName = index
    ? `${fieldNamePrefix}${index}.${ALT_PAY_RATE_NAME}`
    : `${parentFieldName}${ALT_PAY_RATE_NAME}`;
  const payFrequencyName = index
    ? `${fieldNamePrefix}${index}.${ALT_PAY_FREQUENCY_NAME}`
    : `${parentFieldName}${ALT_PAY_FREQUENCY_NAME}`;

  return {
    incomeName,
    hoursWeeksMonthsName,
    payRateName,
    payFrequencyName,
  };
};
const onPayRateChange =
  (fieldNamePrefix, parentFieldName) =>
  ({ target }) => {
    const { payFrequencyName, payRateName, hoursWeeksMonthsName, incomeName } =
      getPayDataFieldNames(fieldNamePrefix, target, parentFieldName);

    onPayDataChange(
      payFrequencyName,
      payRateName,
      hoursWeeksMonthsName,
      incomeName,
    );
  };

// -------------------- Alternate Schema ---------------------

export const ALTERNATE_INCOME_FIELDS = [
  {
    name: `${INCOME_CHECKLIST}.employment`,
    label: 'Employment / Anticipated Employment',
    canHaveMultiple: true,
    addFieldLabel: 'Add Additional Employment',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.employmentList`,
        keyName: lowercaseFirstLetter(ALT_PAY_TYPE_NAME),
        label: 'Select Employment Income Type',
        type: 'employmentIncomeType',
        index: 0,
      },
      {
        name: `${INCOME_CHECKLIST}.employmentList`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
        index: 0,
      },
      {
        name: `${INCOME_CHECKLIST}.employmentList`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
        index: 0,
      },
      {
        name: `${INCOME_CHECKLIST}.employmentList`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
        index: 0,
      },
      {
        name: `${INCOME_CHECKLIST}.employmentList`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
        index: 0,
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.selfEmployment`,
    label: 'Self-Employment',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.selfEmployment${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.selfEmployment${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.selfEmployment${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.selfEmployment${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.militaryPay`,
    label: 'Military Pay',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.militaryPay${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.militaryPay${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.militaryPay${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.militaryPay${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.unearnedIncome17AndUnder`,
    label: 'Unearned Income (17 & Under)',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.unearnedIncome17AndUnder${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.unearnedIncome17AndUnder${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.unearnedIncome17AndUnder${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.unearnedIncome17AndUnder${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.unemploymentBenefits`,
    label: 'Unemployment Benefits',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.unemploymentBenefits${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.unemploymentBenefits${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.unemploymentBenefits${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.unemploymentBenefits${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.socialSecurity`,
    label: 'Social Security, SSD',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.socialSecurity${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.socialSecurity${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.socialSecurity${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.socialSecurityClaimNumber`,
        label: 'SSN Benefits Claim Number (if different from SSN)',
        type: 'text',
      },
      {
        name: `${INCOME_CHECKLIST}.socialSecurity${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.supplementalSecurity`,
    label: 'Supplemental Security Income (SSI)',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurity${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurity${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurity${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurityClaimNumber`,
        label: 'SSN Benefits Claim Number (if different from SSN)',
        type: 'text',
      },
      {
        name: `${INCOME_CHECKLIST}.supplementalSecurity${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.vaBenefits`,
    label: 'V.A. Benefits',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.vaBenefits${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.vaBenefits${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.vaBenefits${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.vaBenefits${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.tanf`,
    label: 'TANF (AFDC)',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.tanf${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.tanf${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.tanf${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.tanf${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.disability`,
    label: "Disability, Worker's Comp.",
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.disability${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.disability${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.disability${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.disability${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.recurringGift`,
    label: 'Recurring Gift',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.recurringGift${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.recurringGift${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.recurringGift${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.recurringGift${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.retirement`,
    label: 'Regular Pmts from Retirement Acct.',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.retirement${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.retirement${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.retirement${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.retirement${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.trust`,
    label: 'Regular Pmts from Trust Acct.',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.trust${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.trust${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.trust${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.trust${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.absentFamilyMember`,
    label: 'Income from Temporarily Absent Family Member',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.absentFamilyMember${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.absentFamilyMember${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.absentFamilyMember${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.absentFamilyMember${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.incomeFromOnlineSources`,
    label: 'Income From Online Sources',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.incomeFromOnlineSources${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.incomeFromOnlineSources${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.incomeFromOnlineSources${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.incomeFromOnlineSources${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.pension`,
    label: 'Pension',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.pension${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.pension${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.pension${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.pension${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.notWorking`,
    label: 'Not Working',
    type: 'choice',
  },
  {
    name: `${INCOME_CHECKLIST}.other`,
    label: 'Other',
    type: 'choice',
    canHaveMultiple: true,
    limit: 10,
    linked: [
      {
        name: `${INCOME_CHECKLIST}.otherList`,
        keyName: 'IncomeName',
        placeholder: 'Other Name',
        type: 'text',
        index: 0,
      },
      {
        name: `${INCOME_CHECKLIST}.otherList`,
        keyName: 'IncomeType',
        label: 'Income Type',
        type: 'incomeType',
        index: 0,
      },
      {
        name: `${INCOME_CHECKLIST}.otherList`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
        index: 0,
      },
      {
        name: `${INCOME_CHECKLIST}.otherList`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
        index: 0,
      },
      {
        name: `${INCOME_CHECKLIST}.otherList`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
        index: 0,
      },
      {
        name: `${INCOME_CHECKLIST}.otherList`,
        keyName: ALT_INCOME_NAME,
        label: GROSS_LABEL,
        type: 'money',
        index: 0,
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.courtOrderedChildSupport`,
    label: 'Do you have court ordered or an agreement for child support?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.courtOrderedChildSupport${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.courtOrderedChildSupport${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.courtOrderedChildSupport${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.courtOrderedChildSupport${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: 'Amount Ordered',
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.collectChildSupport`,
    label: 'Have reasonable efforts been made to collect?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.collectChildSupportState`,
        label: 'State',
        type: 'state',
      },
      {
        name: `${INCOME_CHECKLIST}.collectChildSupportCounty`,
        label: 'County',
        type: 'county',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.receivingChildSupport`,
    label: 'Are you receiving the ordered child support?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.receivingChildSupport${ALT_PAY_FREQUENCY_NAME}`,
        keyName: ALT_PAY_FREQUENCY_NAME,
        label: 'Pay Frequency',
        type: 'payFrequency',
      },
      {
        name: `${INCOME_CHECKLIST}.receivingChildSupport${ALT_PAY_RATE_NAME}`,
        keyName: ALT_PAY_RATE_NAME,
        label: 'Pay Rate',
        type: 'money',
      },
      {
        name: `${INCOME_CHECKLIST}.receivingChildSupport${ALT_HOURS_WEEKS_MONTHS_NAME}`,
        keyName: ALT_HOURS_WEEKS_MONTHS_NAME,
        label: 'Hours/Weeks/Months',
        type: 'number',
      },
      {
        name: `${INCOME_CHECKLIST}.receivingChildSupport${ALT_INCOME_NAME}`,
        keyName: ALT_INCOME_NAME,
        label: 'Amount Receiving',
        type: 'money',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.anticipateChildSupport`,
    label: 'Do you anticipate child support?',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.anticipateChildSupportState`,
        label: 'State',
        type: 'state',
      },
      {
        name: `${INCOME_CHECKLIST}.anticipateChildSupportCounty`,
        label: 'County',
        type: 'county',
      },
    ],
  },
  {
    name: `${INCOME_CHECKLIST}.publicHousing`,
    label: 'Public Housing',
    type: 'choice',
    linked: [
      {
        name: `${INCOME_CHECKLIST}.publicHousingText`,
        label: 'Public Housing Authority',
        type: 'text',
      },
    ],
  },
]
  // Disable all annual gross income fields
  .map((field) => {
    const originalLinkedFields = field?.linked ?? [];
    const linked = originalLinkedFields.map((linkedField) => {
      return {
        ...linkedField,
        disabled: linkedField.keyName === ALT_INCOME_NAME,
      };
    });

    return {
      ...field,
      linked,
    };
  })
  // Add listeners for automatic data calculation
  .map((field) => {
    const originalLinkedFields = field?.linked ?? [];
    const linked = originalLinkedFields.map((linkedField) => {
      const { name } = linkedField;
      const { name: parentFieldName } = field;
      const fieldNameMapToHandler = {
        [ALT_PAY_FREQUENCY_NAME]: onPayFrequencyChange(name, parentFieldName),
        [ALT_PAY_RATE_NAME]: onPayRateChange(name, parentFieldName),
        [ALT_HOURS_WEEKS_MONTHS_NAME]: onHoursWeeksMonthsChange(
          name,
          parentFieldName,
        ),
        default: () => {},
      };

      return {
        ...linkedField,
        onChange:
          fieldNameMapToHandler[linkedField.keyName] ??
          fieldNameMapToHandler.default,
      };
    });

    return {
      ...field,
      linked,
    };
  })
  .map((field) => {
    const originalLinkedFields = field?.linked ?? [];
    const newLinkedFields = [];

    const filteredLinkedFields = originalLinkedFields.filter((linkedField) =>
      [ALT_INCOME_NAME, ALT_HOURS_WEEKS_MONTHS_NAME].includes(field.keyName),
    );

    filteredLinkedFields.forEach((linkedField) => {
      newLinkedFields.push({
        ...linkedField,
        name: `${linkedField.name}Display`,
      });
    });

    const linked = [...originalLinkedFields, ...newLinkedFields];

    return {
      ...field,
      linked,
    };
  });

export const ALT_INCOME_FORM_FIELD_NAMES = ALTERNATE_INCOME_FIELDS.filter(
  (field) => !field.canHaveMultiple,
).map((col) => {
  return col.name.split('.')[1];
});
